import * as React from "react";
import styled from "styled-components";
import * as _ from "lodash";
import { toast } from "react-toastify";

import { Button } from "src/library/components/Button";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";
import { ErrorNotice } from "src/core/shared/components/ErrorNotice";
import { DropMultiSelect } from "src/core/drops/components/DropMultiSelect";

import { useDropsApi } from "../api/drops.api";

export const VanSalesDropsModal: React.ReactFCWithChildren<Pick<BasicModalProps, "onDismiss" | "open"> > = ({ onDismiss, open }) => {
  const [ bulkUpdateRes, bulkUpdateReq ] = useDropsApi("BULK_UPDATE_DROP");
  const [ selectedDrops, setSelectedDrops ] = React.useState<string[]>([]);

  const saveDrops = React.useCallback(() => {
    bulkUpdateReq({
      branchIds: _.map(selectedDrops, dropId => parseInt(dropId)),
      update: { vanSalesOrdering: true }
    });
  }, [ bulkUpdateReq, selectedDrops ]);

  React.useEffect(() => {
    if (bulkUpdateRes.data) {
      toast.success("Successfully saved drops");
      bulkUpdateRes.data = null;
      onDismiss();
    }
  }, [ bulkUpdateRes.data, onDismiss ]);

  return (
    <StyledBasicModal
      title="Add drops to van sales"
      open={open}
      onDismiss={() => onDismiss()}
    >
      {bulkUpdateRes.error && (
        <ErrorNotice
          message={bulkUpdateRes.error.message}
          type="error"
        />
      )}

      {bulkUpdateRes.pending ? (
        <LoadingSpinner type="circular" />
      ) : (
        <>
          <DropMultiSelect
            key="search"
            onDropsChange={change => setSelectedDrops(change.dropsSelected)}
            dropFilters={{ vanSalesOrdering: false }}
          />

          <Button
            disabled={!selectedDrops.length}
            onClick={() => saveDrops()}
          >
            Save
          </Button>
        </>
      )}
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  max-height: calc(100vh - 40px);
  overflow-y: scroll;
  min-height: 400px;

  .submit-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;
